// A failed or unanswered turn, or a proposal that cannot go on, on the page
// ground where the answer would be: the status colour only on the icon and
// the title, the text in muted ink, one action. Not a tinted card: the turn
// failed, the page did not.
import type { ReactNode } from "react";
import { Glyph } from "../ui/icons";

export function TurnState({ tone, title, lines, action }: { tone: "warning" | "danger"; title: string; lines: string[]; action?: ReactNode }) {
  return (
    <div className="turn-state" data-tone={tone} role={tone === "danger" ? "alert" : "status"}>
      <span className="turn-state-icon">
        <Glyph name={tone === "danger" ? "danger" : "warning"} />
      </span>
      <div className="turn-state-body">
        <p className="turn-state-title">{title}</p>
        {lines.map((l) => (
          <p key={l} className="turn-state-text">
            {l}
          </p>
        ))}
        {action ? <div className="turn-state-action">{action}</div> : null}
      </div>
    </div>
  );
}
